module.exports = __webpack_public_path__ + "static/media/fast-forward.9dfc7069.svg";